/**
 * @generated SignedSource<<52faa2b164b7179cc816e6b50e090e57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateCompanyInput = {
  legalName?: string | null;
  name: string;
  organizationId: string;
};
export type useCompanyCreateMutation$variables = {
  input: CreateCompanyInput;
};
export type useCompanyCreateMutation$data = {
  readonly createCompany: {
    readonly company: {
      readonly rowId: any;
      readonly id: string;
      readonly name: string;
      readonly organization: {
        readonly id: string;
        readonly totalCompanies: {
          readonly totalCount: number;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"CompaniesTableRow_company" | "CompanyContextMenu_company">;
    };
  } | null;
};
export type useCompanyCreateMutation = {
  variables: useCompanyCreateMutation$variables;
  response: useCompanyCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v6 = {
  "alias": "totalCompanies",
  "args": [
    {
      "kind": "Literal",
      "name": "includeDeleted",
      "value": "NO"
    }
  ],
  "concreteType": "CompaniesConnection",
  "kind": "LinkedField",
  "name": "companies",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "companies(includeDeleted:\"NO\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompanyCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCompanyPayload",
        "kind": "LinkedField",
        "name": "createCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CompaniesTableRow_company"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CompanyContextMenu_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompanyCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCompanyPayload",
        "kind": "LinkedField",
        "name": "createCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationSubscriptionsConnection",
                    "kind": "LinkedField",
                    "name": "organizationSubscriptions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationSubscription",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentPeriodEnd",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BillingPlan",
                            "kind": "LinkedField",
                            "name": "billingPlan",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "slug",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "legalName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportsConnection",
                "kind": "LinkedField",
                "name": "reports",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportMetricResult",
                "kind": "LinkedField",
                "name": "reportMetrics",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "308f7e42f51f1d463cc6420fed821447",
    "id": null,
    "metadata": {},
    "name": "useCompanyCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useCompanyCreateMutation(\n  $input: CreateCompanyInput!\n) {\n  createCompany(input: $input) {\n    company {\n      rowId\n      id\n      name\n      organization {\n        id\n        totalCompanies: companies(includeDeleted: NO) {\n          totalCount\n        }\n      }\n      ...CompaniesTableRow_company\n      ...CompanyContextMenu_company\n    }\n  }\n}\n\nfragment CompaniesTableRow_company on Company {\n  id\n  rowId\n  name\n  legalName\n  createdAt\n  deletedAt\n  reports {\n    totalCount\n  }\n  reportMetrics {\n    name\n    value\n  }\n  organization {\n    organizationSubscriptions {\n      nodes {\n        currentPeriodEnd\n        billingPlan {\n          slug\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment CompanyContextMenu_company on Company {\n  id\n  deletedAt\n}\n"
  }
};
})();

(node as any).hash = "1faf4cbbf84f7dc2f5fc146b6cca242c";

export default node;
